import DashboardLayout from '../../../shared/DashboardLayout';

const Taxnomies = () => {
  return (
    <DashboardLayout>
      
    </DashboardLayout>
  )
}

export default Taxnomies
